<template>
	<div>
		<input
			type="checkbox"
			@change="emitChange"
			:name="question.Key"
			class="c-inputfields__input--checkbox"
			:id="question.Key"
			v-model="question.Value.UserValue"
		/>
		<label class="value-label c-inputfields__label" :for="question.Key">
			{{ question.Value.Description }}
			<i v-if="question.Value.Required">*</i>
			<info-text :info-text="question.Value.ToolTipText"></info-text>
		</label>
	</div>
</template>

<script>
import InfoText from '@/partials/InfoText';
export default {
	components: { InfoText },
	props: ['question'],
	methods: {
		emitChange: function () {
			this.$emit('updatedvalue', {
				question: this.question,
			});
		},
	},
};
</script>

<style></style>
